module.exports = __webpack_public_path__ + "media/images/icons/staff-management-45d15f05bc8812f000807ca802a8e9ca.svg";